
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pdf/ubicacion_torremm",
      function () {
        return require("private-next-pages/pdf/ubicacion_torremm.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pdf/ubicacion_torremm"])
      });
    }
  